module.exports = __webpack_public_path__ + "img/showShop.beaf9191.png";